<template>
  <div class="basic register-entrance">
    <div class="basic-header">
      <p>- 展区选择 Exhibition Selection -</p>
    </div>

    <!-- <div class="tabs">
      <div class="tabs-top">
        <Row :gutter="10">
          <Col span="6" v-for="(item, index) in area1" :key="index">
          <div class="tag" :class="{ active: areaIndex === index }" @click="areaName = item.name; areaIndex = index">
            <span>{{ item.name }}</span>
          </div>
          </Col>
        </Row>
      </div>
      <div class="tabs-bottom" v-if="area1.length && area1[areaIndex].childrens">
        <Row :gutter="16">
          <Col span="8" v-for="(item, index) in area1[areaIndex].childrens" :key="index">
          <div class="item" :title="item.name" :class="{ active: selectTypeArr && selectTypeArr.name === item.name }"
            @click="addType(item)">{{ item.name }}</div>
          </Col>
        </Row>
      </div>
    </div> -->

    <div class="tabs">
      <div class="tabs-top">
          <Row span="6" v-for="(item, index) in area1" :key="index">
            <div class="tag" :class="{ active: areaIndex === index }" @click="areaName = item.name; areaIndex = index">
              <span>{{ item.name }} {{ item.nameEn }}</span>
            </div>
          </Row>
      </div>
      <div class="tabs-bottom" v-if="area1.length && area1[areaIndex].childrens">
          <Row span="8" v-for="(item, index) in area1[areaIndex].childrens" :key="index">
            <div class="item" :title="item.name" :class="{ active: selectTypeArr && selectTypeArr.name === item.name }"
              @click="addType(item)">{{ item.name }} {{ item.nameEn }}</div>
          </Row>
      </div>
    </div>

    <div class="choice">
      <Row>
        <Col span="24" v-if="company1">
        <div class="choicebox" :class="{ active: select.indexOf(0) !== -1 }" @click="changeArr(0)">
          <div class="choicebox-top" @click.stop="changeSelect(0)">
            <div class="select" v-if="select.indexOf(0) !== -1">已选择</div>
            <div class="select" v-else>选择展会</div>
            <div class="txt1">{{ company1.name }} {{ company1.nameEn }}</div>
            <div class="txt2">时间：{{ company1.startTime | moment("YYYY年MM月DD") }}{{ company1.endTime | moment("-DD日") }} &nbsp;{{ formatEventRange(company1.startTime, company1.endTime) }}
            </div>
            <!-- <div class="txt2">时间：{{ company1.startTime | moment("YYYY年MM月DD日") }} 
            </div>-->
            <div class="txt2">地点：{{ company1.address }} China Import and Export Fair Complex</div>
               <div class="txt2">地址：{{ company1.exHall }} </div>
               <div class="txt2">No. 382, Yuejiang Zhong Road, Haizhu District, Guangzhou, Guangdong</div>
          </div>
          <div class="choicebox-tool">
            <div class="mline" >
              <div style="color:#f00">*</div><div style="font-weight:bold; width: 100%">展位类型 Booth type：</div>
            </div>
            <RadioGroup v-model="companyInp1.areaType" style="font-size:12px; margin: 10px 0;">
              <Radio label="光地 Raw Space" style="font-size:12px"></Radio>
              <Radio label="标摊 Standard booth" style="font-size:12px"></Radio>
            </RadioGroup>
            <div class="mline">
              <span style="color:#f00;display:inline-block;">*</span><span style="font-weight:bold">预订面积 Booth area：</span>
              <InputNumber v-model="companyInp1.showArea" :min="0" :max="9999" style="margin-left:32px;width:100px;">
              </InputNumber>
              <span style="padding-left:10px; display:inline-block;">㎡</span>
            </div>
          </div>
        </div>
        </Col>
        <Col span="24" v-if="company2">
        <div class="choicebox" :class="{ active: select.indexOf(1) !== -1 }" @click="changeArr(1)">
          <div class="choicebox-top" @click.stop="changeSelect(1)">
            <div class="select" v-if="select.indexOf(1) !== -1">已选择</div>
            <div class="select" v-else>选择展会</div>
            <div class="txt1">{{ company2.name }}</div>
            <div class="txt2">时间：{{ company2.startTime | moment("YYYY年MM月DD") }}{{ company2.endTime | moment("-DD日") }}
            </div>
            <div class="txt2">地点：{{ company2.address }}</div>
             <div class="txt2">地址：{{ company2.exHall }}</div>
          </div>
          <div class="choicebox-tool">
            <div class="mline" style="margin-bottom: 10px">
              <span style="color:#f00">*</span><span style="font-weight:bold">展位类型：</span>
              <RadioGroup v-model="companyInp2.areaType" style="padding-left:32px;font-size:12px;">
                <Radio label="光地" style="width:75px;font-size:12px"></Radio>
                <Radio label="标摊" style="font-size:12px"></Radio>
              </RadioGroup>
            </div>
            <div class="mline">
              <span style="color:#f00;display:inline-block;">*</span><span style="font-weight:bold">预订面积：</span>
              <InputNumber v-model="companyInp2.showArea" :min="0" :max="9999" style="margin-left:32px;width:100px;">
              </InputNumber>
              <span style="padding-left:10px; display:inline-block;">㎡</span>
            </div>
          </div>
        </div>
        </Col>
      </Row>
    </div>
    <div class="gap"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: 'register-entrance',
  data () {
    return {
      selectTypeIndex: 0,
      selectTypeArr: null,
      select: [],
      company1: null,
      company2: null,
      productName: '', // 参展展品 
      planAd: '', // 计划广告 
      other: '',
      other2: '',
      areaName: '',
      areaIndex: 0,
      hallCount: 0,
      companyInp1: {
        showArea: 0,
        pType: 'RMB',
        areaName: '',
        areaType: '',
        exhibition: '',
      },
      companyInp2: {
        showArea: 0,
        pType: 'RMB',
        areaName: '',
        areaType: '',
        exhibition: '',
      },
      area1: [],
      area2: [],
      categoryArr: [],
      monthMap: {
          "01": "January",
          "02": "February",
          "03": "March",
          "04": "April",
          "05": "May",
          "06": "June",
          "07": "July",
          "08": "August",
          "09": "September",
          "10": "October",
          "11": "November",
          "12": "December"
      },
    };
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getApplyCompanyGetAreas: 'registerdModule/getApplyCompanyGetAreas',
      GetAllProduct: 'registerdModule/GetAllProduct',
      getExhibitionById: 'registerdModule/getExhibitionById',
    }),

    formatEventRange(start, end) {
        const startM = moment(start).format("MM")
        const startD = moment(start).format("DD")

        const endD = moment(end).format("DD")
        const endY = moment(end).format("YYYY")

        return `${this.monthMap[startM]} ${startD}–${endD}, ${endY}`
    },

    async init () {
      this.getExhibitionHandle(); // 获取固定展会 
    },
    async getGetAllProduct (id) {
      let res = await this.GetAllProduct(id);
      //console.log('getGetAllProduct', res);
      if (res) {
        this.area1 = res;
        if (this.area1[0]) {
          this.areaName = this.area1[0].name || '';
        }
      }
    },
    async getExhibitionHandle () {
      // let res = await this.getExhibitionById('D3DBE69A-CF4B-4CA0-AF71-909C481AB0FF');
    //   let res = await this.getExhibitionById('23D68EEB-A124-4109-A610-127F1042D1DA');
      // let res = await this.getExhibitionById('fd9ac1a3-665d-40ef-a378-8583b10e45a6'); // 94届
      // let res = await this.getExhibitionById('8e6d4e93-d846-464b-8413-2e2afa546bda'); // 95届
      let res = await this.getExhibitionById('134e88fb-aebe-4299-a0f8-28b7f0f1c1f7'); // 96届
      if (res) {
        this.company1 = res;
        this.getGetAllProduct(res.groupId); // 获取固定展会 
      }
      // let res2 = await this.getExhibitionById('875fcbc0-6c24-48b9-a1da-c83c0aec4919');
      // if (res) {
      //   this.company2 = res2;
      // }
      // //console.log('res1', res);
      // //console.log('res2', res2);
    },
    async validHandle () {
      let exhibition = [];// 选中的展会
      if (!this.select.length) {
        this.$Message.error("请选择展会");
        return Promise.resolve({ valid: false });
      }
      let arr = []; // 选中数组
      let errTxt = '';
      if (this.select.indexOf(0) !== -1) {
        exhibition.push(this.company1);
        this.companyInp1.exhibition = this.company1;
        arr.push(this.companyInp1);
      }
      if (this.select.indexOf(1) !== -1) {
        exhibition.push(this.company2);
        this.companyInp2.exhibition = this.company2;
        arr.push(this.companyInp2);
      }
      //console.log('arr', arr);
      if (!this.areaName) {
        errTxt = "请选择展区";
      }
      if (!this.selectTypeArr) {
        errTxt = "请选择展区类型";
      }

      arr.forEach(c => {
        if (!c.areaType) {
          errTxt = "请选择展位类型";
          return;
        }
        if (this.companyInp1.areaType === '标摊') {
          if (c.showArea) {
            if (c.showArea < 9) {
              errTxt = "标摊9平米起售、光地36平起售";
              return;
            }
          } else {
            errTxt = "请输入预定面积";
            return;
          }
        }
        if (this.companyInp1.areaType === '光地') {
          if (c.showArea) {
            if (c.showArea < 36) {
              errTxt = "标摊9平米起售、光地36平起售";
              return;
            }
          } else {
            errTxt = "请输入预定面积";
            return;
          }
        }
      });
      if (errTxt) {
        this.$Message.error(errTxt);
        return Promise.resolve({ valid: false });
      }
      let order = null;
      if (arr[0]) {
        order = {
          exhibitionId: arr[0].exhibition.id,
          pType: arr[0].pType,
          areaType: arr[0].areaType,
          showArea: arr[0].showArea,
        };
      }
      let res = {
        ApplyCompanyOrderNewDto: order || {},
        // ApplyCompanyOrder2: order2 || {},
        exhibition: exhibition,
        comon: {
          deExHipkind: `${this.areaName}/${this.selectTypeArr.name}`
        }
      }
      //console.log('validHandle', res);
      return Promise.resolve({ valid: true, ...res });
    },
    changeArr (index) {
      if (this.select.indexOf(index) === -1) {
        this.select.push(index);
      }
    },
    changeSelect (index) {
      if (this.select.indexOf(index) === -1) {
        this.select.push(index);
      } else {
        this.select.splice(this.select.indexOf(index), 1);
      }
    },
    addType (item) {
      if (this.selectTypeArr && this.selectTypeArr.name === item.name) {
        this.selectTypeArr = null;
      } else {
        this.selectTypeArr = item;
      }
      //console.log('addType:', this.selectTypeArr);
    }
  },
}

</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #4f65ae !important;
    }

    .ivu-radio-inner:after {
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }

    .ivu-switch-checked {
      border-color: #4f65ae;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }
  }

  &-header {
    width: 100%;
    height: 45px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 45px;
      font-size: 15px;
    }

    span {
      width: 30px;
      height: 15px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-title {
    line-height: 48px;
    font-size: 18px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;

    span {
      font-size: 14px;
    }
  }
}

.choice {
  margin-bottom: 30px;
}

.choicebox {
  background-color: #fff;
  margin: 0 15px 15px;
  border: solid 1px #e5e5e5;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;

  &.active {
    background-color: #f2f4fb;
    border: solid 1px #4f65ae;

    .select {
      opacity: 1;
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
      border-color: #4f65ae;
      color: #fff;
    }

    .choicebox-top {
      border-color: #4f65ae;
    }

    .choicebox-tool::before {
      background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
        linear-gradient(#b10042, #b10042);
    }
  }

  .select {
    opacity: 0;
    border-radius: 0px 0px 0px 5px;
    position: absolute;
    text-align: center;
    top: 0;
    right: 0;
    width: 50px;
    height: 21px;
    line-height: 21px;
    background-color: #f2f4fb;
    border: solid 1px #f2f4fb;
    font-size: 12px;
    color: #4f65ae;
  }

  &-top {
    padding: 10px 15px 5px;

    .txt1 {
      font-size: 15px;
      color: #4f65ae;
      font-weight: bold;
      margin-bottom: 5px;
    }

    .txt2 {
      font-size: 12px;
      color: #666;
      margin-bottom: 4px;
    }
  }

  &-content {
    .title {
      font-size: 15px;
      color: #333;
      margin-bottom: 15px;
      font-weight: 600;
      padding: 15px;
    }

    .item {
      display: flex;
      align-items: center;
      flex: 1;
      flex-wrap: nowrap;

      &-box {
        width: 120px;
        white-space: normal;
        padding-right: 4px;
      }

      &-box2 {
        width: 60%;
        white-space: normal;
        padding-right: 10px;

        p {
          font-size: 12px;
          color: #333;
          font-weight: normal;
        }
      }
    }

    ::v-deep {
      .ivu-radio-group-item {
        padding-left: 12px;
        padding-top: 6px;
        padding-bottom: 6px;
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 45px;
        border-bottom: solid 1px #e5e5e5;
        border-left: solid 1px #e5e5e5;
        border-right: solid 1px #e5e5e5;

        &:first-child {
          border-top: solid 1px #e5e5e5;
        }
      }
    }
  }

  &-tool {
    margin: 0 15px;
    font-size: 12px;
    padding: 10px 0;
    position: relative;

    .mline {
      display: flex;
      align-items: center;
      font-size: 12px;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 200%;
      margin-left: -15px;
      height: 1px;
      background: #e5e5e5;
    }
  }
}

.select-box {
  .select-content {
    margin: 15px;
    border-radius: 3px;
    border: solid 1px #e5e5e5;
  }

  .s-mobile {
    ::v-deep {
      .ivu-radio-group {
        width: 100%;
      }

      .ivu-radio-group-item {
        width: 100%;
        display: inline-block;
        margin: 0;
      }

      .ivu-radio-group-vertical .ivu-radio-wrapper {
        height: 45px;
        line-height: 45px;
        padding-left: 12px;
        border-bottom: 1px solid #e5e5e5;
        font-size: 13px;
        color: #333;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}

.under-btn {
  ::v-deep {
    .ivu-input {
      position: relative;
      top: -2px;
      border: none;
      border-bottom: 1px solid #bfbfbf;
      border-radius: 0;

      &:hover,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }
}

.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;

  &.s-noline {
    border-bottom: none;
  }

  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    margin-right: 7px;
  }

  span {
    font-size: 15px;

    .upload-btn2 {
      width: 105px;
      height: 105px;
      border: dotted 1px #bfbfbf;
      text-align: center;
      margin: 10px 16px;
      border-radius: 4px;
      position: relative;
      margin-left: 10px;

      img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }

    color: #f00;
  }

  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}

.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}

.license-img {
  width: 105px;
  height: 105px;
  border: dotted 1px #bfbfbf;
  text-align: center;
  margin: 10px 16px;
  border-radius: 4px;
}

.tabs {
  margin-bottom: 30px;
  margin: 20px 15px 15px;

  &-top {
    width: 100%;
    color: #666;
    font-size: 12px;

    .tag {
      width: 100%;
      line-height: 48px;
      text-align: center;
      background-blend-mode: normal, normal;
      border-bottom: none;
      cursor: pointer;
      position: relative;
      border-left: solid 1px #4f9edd;
      border-right: solid 1px #4f9edd;
      border-top: solid 1px #4f9edd;
      // border-radius: 5px 5px 0px 0px;
      overflow: hidden;

      span {
        position: relative;
        z-index: 1;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      &:hover,
      &.active {
        background-color: transparent;
        color: #fff;

        &::before {
          background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
            linear-gradient(#f2f2f2, #f2f2f2);
        }
      }
    }
  }

  &-bottom {
    border: solid 1px #4f9edd;
    padding: 15px 15px 0;

    .item {
      cursor: pointer;
      width: 100%;
      text-align: center;
      font-size: 12px;
      line-height: 32px;
      border-radius: 5px;
      background-color: #f7f7f7;
      color: #666;
      margin-bottom: 20px;
      padding: 0 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.active {
        background-color: #4f9edd;
        color: #fff;
      }
    }
  }
}
</style>
